<template>
	<svg @click="click" style="cursor: pointer" width="32" height="32" viewBox="0 0 32 36" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M2.2115 30.4935C1.89456 30.4935 1.58489 30.3677 1.35505 30.1403C1.06956 29.8548 0.943756 29.4435 1.02359 29.0492L2.73408 20.4968C2.78247 20.2597 2.89376 20.0443 3.06553 19.8774L21.8833 1.05968C23.2962 -0.353226 25.6018 -0.353226 27.0147 1.05968L30.4357 4.48064C31.851 5.89597 31.851 8.19677 30.4357 9.61209L11.6179 28.4298C11.451 28.5992 11.2357 28.7129 10.9986 28.7613L2.44618 30.4718C2.36876 30.4863 2.28892 30.4935 2.2115 30.4935ZM5.03731 21.3266L3.75505 27.7403L10.1688 26.4581L28.7276 7.89919C29.1994 7.42742 29.1994 6.66048 28.7276 6.18871L25.3067 2.76774C24.8349 2.29597 24.0679 2.29597 23.5962 2.76774L5.03731 21.3266ZM10.7639 27.5734H10.7881H10.7639Z"
			fill="#0096D6"
		/>
		<path d="M2 34H30" stroke="#0096D6" stroke-width="2.5" stroke-linecap="round" />
	</svg>
</template>

<script>
	export default {
		name: 'EditSVG',
		methods: {
			click() {
				this.$emit('click');
			}
		}
	};
</script>

<style scoped>
	svg {
		z-index: 0;
	}
</style>
